import { render } from "./CreatedImageView.vue?vue&type=template&id=5a7edcfe&scoped=true"
import script from "./CreatedImageView.vue?vue&type=script&lang=js"
export * from "./CreatedImageView.vue?vue&type=script&lang=js"

import "./CreatedImageView.vue?vue&type=style&index=0&id=5a7edcfe&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7edcfe"]])

export default __exports__